Page = {

	current: {},
	useAnimationBlocks: true,
	animationTime: 1001,

	load: function (PAGE, URL) {

		if (App.debug) {
			console.log('--- Page.load -----------------------------');
			console.log('Router', Router);
			console.log('PAGE', PAGE);
			console.log('URL', URL);
		}

		PAGE.addClass('loading');
		this.Loader.show(PAGE);

		$.ajax({
			type: "POST",
			url: WEB_ROOT + "/" + URL,
			beforeSend: function () { },
			success: function (result) {
				if (!result) return;
				Page.add(PAGE, URL, result);
				return;
			},
			error: function (jqXHR, textStatus, errorThrown) {
				console.log("ERROR", jqXHR, textStatus, errorThrown);
			}
		});
	},

	add: function (PAGE, URL, html) {
		if (App.debug) {
			console.log('--- Page.add -----------------------------');
			console.log('PAGE', PAGE);
			console.log('html', html);
		}

		var popup = $('<div>').hide().html(html).find('[component="page"][type="popup"]');

		if (popup.length && !Page.hasPopup) {
			Page.openPopup(popup);
			return;
		}

		PAGE.attr('url', URL);

		var oldContent = PAGE.find('content');
		oldContent
			.removeClass(oldContent.attr('anim-in'))
			.addClass(oldContent.attr('anim-out'));

		var oldContentHeight = oldContent.outerHeight();

		// console.log(oldContent.attr('anim-out'), oldContent.attr('anim-in'), oldContent)

		var newContent = $('<div>').hide().html(html).find('content').first();
		newContent
			.attr({ "state": "added", "content": Router.path })
			.removeClass(newContent.attr('anim-out'))
			.addClass(newContent.attr('anim-in'))
			.appendTo(PAGE);

			// console.log(newContent);

		PAGE
			.removeClass('loading')
			.addClass('showing');

		this.init(PAGE);

		setTimeout(function(){
			Page.show(PAGE);
		},10)
	},

	init: function (PAGE) {

		if (typeof Editor != "undefined") return;

		if (App.debug) {
			console.log('--- Page.init -----------------------------');
			console.log('arguments', arguments);
		}

		References.init(PAGE);
		Router.bindAnchors(PAGE);
		// Picture.init(PAGE);
		ProfileButton.init(PAGE);
		YouTubeVideo.resize();
		initAjaxForms();
		Form.init();
		Iframe.init();
		Scroller.init(PAGE);
		Keyboard.init(PAGE);

		Porfolio.init(PAGE);
		sbAccordion.init(PAGE);
		Expander.init(PAGE);
		audioTrackInit();

		setTimeout(function(){
			onloadRecaptchaCallback();
		}, 10);

		// $('[component="page"] content').animate({scrollTop:0},500);
		// Scroller.el.scroll && Scroller.el.scroll(0,500);

		
	},

	show: function (PAGE) {

		var oldContent = PAGE.find('content[state="ready"], content:not([state]), content[state="show"]')
			.attr('state', 'hide');

		var newContent = PAGE.find('content[state="added"]')
			.attr('state', 'show');

		if (this.useAnimationBlocks) {
			Block.hide(oldContent.find('[anim-type]'));

			var newBlocks = newContent.find('[anim-type]').addClass('hidden');
			Block.show(newBlocks);
		}

		setTimeout(function () {
			Page.change(PAGE);
		}, Page.animationTime)

		this.Loader.hide(PAGE);

	},

	change: function (PAGE) {

		if (this.useAnimationBlocks) {
			var newBlocks = PAGE.find('content[state="show"]').find('[anim-type="after"]');
			Block.show(newBlocks);
		}

		PAGE.removeAttr('show').attr('ready', '');
		PAGE.attr('ready', '');
		PAGE.find('content[state="show"]').attr('state', 'ready');
		PAGE.removeClass('showing');

		Page.remove(PAGE);
	},

	remove: function (PAGE) {
		PAGE.find('[state="hide"]').remove();
		PAGE.removeAttr('style');
	},

	reset: function (PAGE, URL) {

		if (App.debug) {
			console.log('--- Page.reset -----------------------------');
			console.log('PAGE', PAGE);
			console.log('URL', URL);
		}

		$.ajax({
			type: "POST",
			url: WEB_ROOT + '/' + URL,
			beforeSend: function () { },
			success: function (result) {
				if (!result) return;
				Page.replaceContent(result, URL, PAGE);
				return;
			},
			error: function (jqXHR, textStatus, errorThrown) {
				console.log("ERROR", jqXHR, textStatus, errorThrown);
			}
		});
	},

	replaceContent: function (html, URL, PAGE) {

		if (App.debug) {
			console.log('--- Page.replaceContent -----------------------------');
			console.log('page', PAGE);
			console.log('pageUrl', URL);
		}

		var content = $('<div>').hide().html(html).find('content').first();
		PAGE.find('content').replaceWith(content);
		PAGE.attr('url', URL);
		Page.init(PAGE);
	},

	openPopup: function (popup) {
		if (App.debug) {
			console.log('--- Directory.openPopup -----------------------------');
		}

		Page.hasPopup = true;

		var refButton = $('a.button[href="/' + popup.attr('url') + '"]').closest('.cell');

		popup
			.attr({ "content": Router.path, "load": "" })
			.css({
				left: refButton.offset().left + refButton.outerWidth() / 2,
				top: refButton.offset().top,
				width: refButton.outerWidth(),
				height: refButton.outerHeight(),
			})
			.prependTo('[component="directory"] .os-content')

		Page.init(popup);

		setTimeout(function () {
			popup
				.addClass('show')
				.removeAttr('load');
		}, 500);

		Scroller.el.sleep();
		$('[component="directory"] > .os-scrollbar').css({ display: 'none' });
		$('[component="directory"] > .os-padding > .os-viewport').css({ overflowY: 'hidden' });
	},

	closePopup: function () {
		if (!App.debug) {
			console.log('--- Directory.closePopup -----------------------------');
		}
		Page.hasPopup = false;

		var popup = $('[component="directory"] [component="page"][type="popup"]');
		var refButton = $('a.button[href="/' + popup.attr('url') + '"]').closest('.cell');

		if (!refButton.length) {
			popup.remove();
			return;
		}

		popup
			.removeClass('show')
			.addClass('hide')
			.css({
				left: refButton.offset().left + refButton.outerWidth() / 2,
				top: refButton.offset().top,
				width: refButton.outerWidth(),
				height: refButton.outerHeight()
			})

		setTimeout(function () {
			popup.remove();
		}, 500);

		$('[component="directory"] > .os-scrollbar').removeAttr('style');
		$('[component="directory"] > .os-padding > .os-viewport').css({ overflowY: 'scroll' });
		Scroller.el.update();
	},

	Loader: {
		button: {},
		show: function (PAGE) {
			// var overlay = $('<div>', {"class": "overlay"}).prependTo(PAGE)
			// setTimeout(function(){overlay.addClass('show')},1);

			var webRoot = "/";

			var url = webRoot + Router.path;
			this.button = $('[href="' + url + '"]');
			this.button.attr('load', true);
		},

		hide: function (PAGE) {
			// console.log('overlay hide', Page.current.find('.overlay'));
			// PAGE.find('.overlay').removeClass('show');
			// setTimeout(function(){PAGE.find('.overlay').remove(); },500);
			$('[load]').removeAttr('load');
		}
	}

}

